import { Cone } from "drei";
import { heightAtLatLng } from "../../utils/mapping-functions";
import SETTINGS from "../../settings";

const Obelisks = (props) => {
  // '🏴', '🌳', '🏛', '🌻', '⭐️', '🚧', '🚙'
  const heightMap = props.heightMap;
  const poiMarkers = props.poiMarkers;
  const scale = SETTINGS.TERRAIN.SCALE;
  let obelisks = [];

  for (let i = 0; i < poiMarkers.length; i++) {
    let point = heightAtLatLng(poiMarkers[i].latLng, heightMap);
    let vert = {};
    vert.name = poiMarkers[i].name;
    vert.x =
      (point.x * heightMap.boundBox.size.x - heightMap.boundBox.size.x / 2) /
      scale;
    vert.z = (point.z - heightMap.heightLimits.min) / scale;
    vert.y =
      (point.y * heightMap.boundBox.size.y - heightMap.boundBox.size.y / 2) /
      scale;
    obelisks.push(vert);
  }

  return (
    <group>
      {obelisks.map((point, i) => {
        let obeliskColour, obeliskEmissive, obeliskSize;
        switch (point.name) {
          case "🏴":
            obeliskColour = 0xaa0000;
            obeliskEmissive = 0xaa0000;
            obeliskSize = [0.002, 0.01, 3]; //radius, height, segments
            break;
          case "🌳":
            obeliskColour = 0x00bb00;
            obeliskEmissive = 0x00ee00;
            obeliskSize = [0.006, 0.006, 12];
            break;

          case "🏛":
            obeliskColour = 0x706fd3;
            obeliskEmissive = 0x000000;
            obeliskSize = [0.003, 0.006, 6];
            break;
          case "🌻":
            obeliskColour = 0xffaa00;
            obeliskEmissive = 0x000000;
            obeliskSize = [0.001, 0.001, 12];
            break;
          case "⭐️":
            obeliskColour = 0xffff00;
            obeliskEmissive = 0xffff00;
            obeliskSize = [0.003, 0.01, 5];
            break;
          case "🚧":
            obeliskColour = 0x503077;
            obeliskEmissive = 0x000000;
            obeliskSize = [0.003, 0.006, 6];
            break;
          case "🚙":
            obeliskColour = 0x555555;
            obeliskEmissive = 0x000000;
            obeliskSize = [0.003, 0.006, 6];
            break;
        }
        return (
          <Cone
            key={i}
            castShadow
            args={obeliskSize}
            position={[point.x, point.z + obeliskSize[1] / 2, point.y]}
            rotation={[Math.PI, 0, 0]}
          >
            <meshLambertMaterial
              attach="material"
              emissive={obeliskEmissive}
              color={obeliskColour}
              flatShading={true}
            />
          </Cone>
        );
      })}
    </group>
  );
};

export default React.memo(Obelisks);
